<template>
  <lu-app id="app" class='app-main'>
    <router-view  v-if='isConnected' />
    <lu-vbox lu-vcenter lu-hcenter lu-flex v-else-if='isError' >
      error
    </lu-vbox>
    <lu-vbox lu-vcenter lu-hcenter lu-flex v-else>
      loading
    </lu-vbox>
  </lu-app>
</template>

<script>
import { LuApp, LuVbox } from 'lusis-ui'
import { mapGetters } from 'vuex'
import messageHandler from '@/mixins/message'
import version from '@/version'
// import Storage from '@/utils/storage'

export default {
  name: 'App',
  components: { LuApp, LuVbox },
  mixins: [ messageHandler ],
  data () {
    return  {
      isConnected: false,
      isError: false
    }
  },
  mounted: function () {
    this.handleEscapeKey()
  },
  computed: {
    ...mapGetters( ['tangoStatus', 'isLoggedIn'] )
  },
  created () {
    this.loadConfigTango().then(() => {
      this.isConnected = true
    }).catch(() => {
      this.isError = true
    })
  },
  beforeDestroy: function () {
    if (this.tangoStatus === 3) {
      this.removeMessagesHandler()
    }
  },
  methods: {
    handleEscapeKey () {

      let title = document.querySelector('head > title')

      title.innerHTML += ' : ' + version

      let self = this
      document.addEventListener('keydown', function (e) {
        e = e || window.event
        let k = e.keyCode
        let blockBackspace = e.target === document.body || (e.target && /lu-scrollarea/.test(e.target.className))
        if ((k === 8 && blockBackspace) || (k === 116 && self.isLoggedIn)) {
          e.preventDefault()
          return false
        }
        return true
      })
      history.pushState(null, document.title, location.href)
      window.addEventListener('popstate', function (e) {
        e = e || window.event
        if (self.isLoggedIn) {
          e.preventDefault()
          history.pushState(null, document.title, location.href)
        }
      })
      window.addEventListener('beforeunload', function (e) {
        e = e || window.event
        if (self.isLoggedIn) {
          e.preventDefault()
          e.returnValue = self.$t('Are you sure you want to exit ?')
          if (e.returnValue) self.logout()
          return e.returnValue
        }
      })
    }
  }
}
</script>
